import { Toggle } from '@pmi/dsm-react';
import { FieldMetaProps } from 'formik';
import { ChangeEvent, KeyboardEvent, useMemo } from 'react';
import { AgreementApiModel } from '../../../shared/models/DealModel';
import styles from './settingsToggle.module.scss';

export interface SettingsToggleProps {
  deal: AgreementApiModel;
  type: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  setFieldTouched: (
    field: string,
    isTouched?: boolean,
    shouldValidate?: boolean,
  ) => void;
  getFieldMeta: (name: string) => FieldMetaProps<any>;
  isDisabled: boolean;
  status?: any;
}

const checkedMessage = {
  enabled: 'Enabled',
  hidden: 'Hidden',
  reseller: 'Active',
};

const uncheckedMessage = {
  enabled: 'Disabled',
  hidden: 'Shown',
  reseller: 'Inactive',
};

export default function SettingsToggle({
  deal,
  setFieldValue,
  setFieldTouched,
  type,
  isDisabled,
  getFieldMeta,
  status = [],
}: SettingsToggleProps) {
  const name = `${deal.id}.${type}`;

  const description = getFieldMeta(name).value
    ? checkedMessage[type]
    : uncheckedMessage[type];
  const isChecked = useMemo(
    () => getFieldMeta(name).value,
    [getFieldMeta(name).value],
  );

  const handleChange = (
    event: ChangeEvent<HTMLInputElement> | KeyboardEvent<HTMLInputElement>,
  ) => {
    setFieldTouched(event.currentTarget.name, true);
    setFieldValue(
      event.currentTarget.name,
      type === 'hidden'
        ? !event.currentTarget.checked
        : event.currentTarget.checked,
    );
  };
  let settingChanged = false;
  if (status[`${deal.id}`]) {
    const dealStatus = status[`${deal.id}`];
    if (Object.hasOwn(dealStatus, type)) {
      settingChanged = true;
    }
  }

  return (
    <div
      className={`${styles.toggleContainer} ${
        settingChanged ? styles.settingChanged : styles.settingDefault
      }`}
    >
      <Toggle
        name={name}
        onChange={handleChange}
        disabled={isDisabled}
        textOn={description}
        textOff={description}
        checked={type === 'hidden' ? !isChecked : isChecked}
      />
    </div>
  );
}
